import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { DateRangePicker, Modal } from 'rsuite';
import axios from 'axios';
import useAccessToken from '../../hooks/AccessToken';
import useSWR from 'swr';
import { exportExcelInvoice } from '../../functions/ExportExcel/reportInvoice';
import moment from 'moment-timezone';

interface ModalSettingDateInvoiceProps {
    selectMultiPipelineCustomField: any;
    selectTemplateIdPipeline: string;
    isOpen: boolean;
    onClose: () => void;
}

const API_URL = process.env.REACT_APP_API_URL;

const ModalSettingDateInvoice: React.FC<ModalSettingDateInvoiceProps> = ({ selectMultiPipelineCustomField, selectTemplateIdPipeline, isOpen, onClose }) => {
    const intl = useIntl();
    const [dateRange, setDateRange] = useState<[Date, Date] | null>(null);
    const token = useAccessToken();
    const [isExporting, setIsExporting] = useState(false);
    const [totalData, setTotalData] = useState(0);
    const [isFirstFetch, setIsFirstFetch] = useState(false);

    const fetcher = async (url: string) => {
        const response = await axios.get(url, {
            headers: {
                'X-Auth-token': token
            }
        });

        setTotalData(response.data.data.length);
        setIsFirstFetch(true);
        return response.data.data;
    };

    const formatDateForUrl = (date: Date) => {
        // return moment(date).format('YYYY-MM-DD HH:mm');
        return moment(date).format('YYYY-MM-DD');
    };

    const getApiUrl = () => {
        if (!selectTemplateIdPipeline) return null;

        if (dateRange) {
            // return `${API_URL}receivable-reports/list/invoice-maspion?leadTemplateId=${selectTemplateIdPipeline}&start_date_pipe=${formatDateForUrl(new Date(dateRange[0].setHours(0, 0, 0, 0)))}&end_date_pipe=${formatDateForUrl(new Date(dateRange[1].setHours(23, 59, 59, 999)))}`;
            return `${API_URL}receivable-reports/list/invoice-maspion?leadTemplateId=${selectTemplateIdPipeline}&start_date_pipe=${formatDateForUrl(dateRange[0])}&end_date_pipe=${formatDateForUrl(dateRange[1])}`;
        }
    };

    const { data: dataExport, mutate } = useSWR(
        getApiUrl(),
        fetcher,
        {
            revalidateOnFocus: false,
            refreshInterval: 0
        }
    );

    const handleDateRangeChange = (value: [Date, Date] | null) => {
        setDateRange(value);
        mutate();
    };

    const handleSubmit = async () => {
        if (dateRange && dataExport?.length > 0) {
            try {
                setIsExporting(true);
                await mutate();
                await exportExcelInvoice(
                    selectMultiPipelineCustomField?.name,
                    dataExport,
                    selectTemplateIdPipeline,
                    dateRange
                );
            } catch (error) {
                console.error('Error exporting data:', error);
            } finally {
                setIsExporting(false);
            }
        }
    };

    useEffect(() => {
        const getRsModalWrapper: HTMLDivElement | null = document.querySelector('.rs-modal-wrapper')
        if (getRsModalWrapper) {
            getRsModalWrapper.style.display = 'flex'
            getRsModalWrapper.style.alignItems = 'center'
            getRsModalWrapper.style.justifyContent = 'center'
        }
    }, [])

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Modal.Header>
                <Modal.Title>Pilih Rentang Tanggal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DateRangePicker
                    value={dateRange}
                    onChange={handleDateRangeChange}
                    format="dd MMM yyyy"
                    placeholder={intl.formatMessage({ id: "FORM.LABEL.SELECT_DATE_RANGE" })}
                    className="w-100"
                />
                {
                    isFirstFetch && (
                        <div className='mt-3'>
                            Total Data : {totalData}
                        </div>
                    )
                }
            </Modal.Body>
            <Modal.Footer>
                <div className="text-end mt-10">
                    <button
                        type="button"
                        className="btn btn-light me-3"
                        onClick={onClose}
                        disabled={isExporting}
                    >
                        Batal
                    </button>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                        disabled={!dateRange || isExporting || totalData === 0}
                    >
                        {isExporting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Mengexport...
                            </>
                        ) : (
                            'Export Excel'
                        )}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalSettingDateInvoice